export default function convertLatesFromMinutesToHours(row) {
    const minutes = row.hours_tardy || 0;
    const hours = minutes / 60;
    return {
        ...row,
        hours_tardy: minutes
    }
}